module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/event/certificate/validate/validate.component.css
// module id = ./src/app/event/certificate/validate/validate.component.css
// module chunks = main